import "./Doodles.css";

const COLORS = {
    pink: "#ff4fd8",
    blue: "#4d8dff",
    green: "#3dff88",
    yellow: "#e4ff1a",
};

const Sparkle = ({ color }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M12 1l2.4 8.6L23 12l-8.6 2.4L12 23l-2.4-8.6L1 12l8.6-2.4L12 1z"
            fill={color}
        />
    </svg>
);

const Ring = ({ color }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2.5" />
    </svg>
);

const Plus = ({ color }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M12 4v16M4 12h16"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
        />
    </svg>
);

const Squiggle = ({ color }) => (
    <svg viewBox="0 0 40 12" fill="none" aria-hidden="true">
        <path
            d="M2 6c3-5 6-5 9 0s6 5 9 0 6-5 9 0 6 5 9 0"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
        />
    </svg>
);

const SHAPES = { sparkle: Sparkle, ring: Ring, plus: Plus, squiggle: Squiggle };

export const Doodles = ({ items = [] }) => (
    <>
        {items.map((item, i) => {
            const Shape = SHAPES[item.type] || Sparkle;
            return (
                <span
                    key={`${item.type}-${i}`}
                    className="doodle"
                    style={{
                        ...item.style,
                        width: item.size || 24,
                        height: item.size || 24,
                        animationDelay: item.delay || "0s",
                    }}
                    aria-hidden="true"
                >
                    <Shape color={COLORS[item.color] || COLORS.pink} />
                </span>
            );
        })}
    </>
);
